import { all, takeEvery, put, fork, call } from 'redux-saga/effects'
import {
  AUTH_TOKEN,
  TENANT_ID,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_FACEBOOK,
  HIDE_POPUP_INITIALSETUP,
  HIDE_POPUP_VIEWBARCODE,
  HIDE_POPUP_NEWSETTING,
  HIDE_POPUP_APPLYSETTING,
  TENANT_CREATED_TIME,
  LOGIN_TYPE,
  SHOW_POPUP,
  FETCH_USER_PERMISSION_FIREBASE,
} from '../constants/Auth'
import {
  showAuthMessage,
  authenticated,
  signOutSuccess,
  signUpSuccess,
  signInWithGoogleAuthenticated,
  signInWithFacebookAuthenticated,
} from '../actions/Auth'
import FirebaseService from 'services/FirebaseService'
import SSOService from 'services/SSOService'
import { GOOGLE_DRIVE_TOKEN } from 'constants/Constant'

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { email, password } = payload
    console.log('Trying to sign in with email password')
    console.log(payload)
    try {
      const user = yield call(FirebaseService.signInEmailRequest, email, password)
      console.log(user)
      if (user.message) {
        yield put(showAuthMessage(user.message))
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid)
        console.log(user.user.uid)
        yield put(authenticated(user.user.uid))
      }
    } catch (err) {
      yield put(showAuthMessage(err))
    }
  })
}

export function* signOut() {
  yield takeEvery(SIGNOUT, function* ({ payload }) {
    try {
      console.log('payload: ', payload)
      localStorage.setItem(LOGIN_TYPE, payload)

      // Clear SSO session for SSO login
      SSOService.logout()

      const signOutUser = yield call(FirebaseService.signOutRequest)
      if (signOutUser === undefined) {
        localStorage.removeItem(HIDE_POPUP_INITIALSETUP)
        localStorage.removeItem(HIDE_POPUP_VIEWBARCODE)
        localStorage.removeItem(HIDE_POPUP_NEWSETTING)
        localStorage.removeItem(HIDE_POPUP_APPLYSETTING)
        //localStorage.removeItem(EMAIL_ID)
        //localStorage.removeItem(ROLE)
        localStorage.removeItem(TENANT_ID)
        localStorage.removeItem(TENANT_CREATED_TIME)
        //localStorage.removeItem(FIREBASE_USERNAME)
        localStorage.removeItem(GOOGLE_DRIVE_TOKEN.ACCESSTOKEN)
        localStorage.removeItem(GOOGLE_DRIVE_TOKEN.ACCESSTOKEN_EXPIRY)
        yield put(signOutSuccess(signOutUser))
        localStorage.removeItem(LOGIN_TYPE)
        localStorage.removeItem(SHOW_POPUP)
      } else {
        yield put(showAuthMessage(signOutUser.message))
        localStorage.removeItem(LOGIN_TYPE)
        localStorage.removeItem(SHOW_POPUP)
      }
      localStorage.removeItem(FETCH_USER_PERMISSION_FIREBASE)
    } catch (err) {
      yield put(showAuthMessage(err))
      localStorage.removeItem(LOGIN_TYPE)
      localStorage.removeItem(SHOW_POPUP)
    }
  })
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    const { email, password } = payload
    try {
      const user = yield call(FirebaseService.signUpEmailRequest, email, password)
      if (user.message) {
        yield put(showAuthMessage(user.message))
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid)
        yield put(signUpSuccess(user.user.uid))
      }
    } catch (error) {
      yield put(showAuthMessage(error))
    }
  })
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
    try {
      const user = yield call(FirebaseService.signInGoogleRequest)
      if (user.message) {
        yield put(showAuthMessage(user.message))
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid)
        yield put(signInWithGoogleAuthenticated(user.user.uid))
      }
    } catch (error) {
      yield put(showAuthMessage(error))
    }
  })
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
    try {
      const user = yield call(FirebaseService.signInFacebookRequest)
      if (user.message) {
        yield put(showAuthMessage(user.message))
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid)
        yield put(signInWithFacebookAuthenticated(user.user.uid))
      }
    } catch (error) {
      yield put(showAuthMessage(error))
    }
  })
}

export default function* rootSaga() {
  yield all([
    fork(signInWithFBEmail),
    //fork(signInWithCustomToken),
    fork(signOut),
    fork(signUpWithFBEmail),
    fork(signInWithFBGoogle),
    fork(signInWithFacebook),
  ])
}
